import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import type { Brief } from "@crucible/types";
import { useApi } from "@/app/providers/ApiProvider";
import { PageHeader } from "@/shared/ui/PageHeader";

export function BriefPage() {
  const api = useApi();
  const { slug = "atlas" } = useParams();
  const [brief, setBrief] = useState<Brief | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setBrief(null);
    setError(null);
    api
      .getBrief(slug)
      .then((data) => {
        if (active) setBrief(data);
      })
      .catch((err: Error) => {
        if (active) setError(err.message);
      });
    return () => {
      active = false;
    };
  }, [api, slug]);

  return (
    <section>
      <PageHeader
        eyebrow="Brief"
        title={slug}
        subtitle="Flagship weekly brief surface (migrated from frontend/app/brief.html)."
      />
      {error && <p className="muted">{error}</p>}
      {brief && (
        <div className="metrics">
          <Metric label="Momentum" value={brief.scores.momentum} />
          <Metric
            label="Plan adherence"
            value={`${brief.scores.plan_adherence}%`}
          />
          <Metric
            label="Demo readiness"
            value={`${brief.scores.demo_readiness}%`}
          />
          <Metric label="Evidence" value={brief.evidence_count} />
        </div>
      )}
    </section>
  );
}

function Metric({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="metric">
      <span className="metric__label">{label}</span>
      <strong className="metric__value">{value}</strong>
    </div>
  );
}